import React from "react";
import { Button } from "@mui/material";

const EmployeeFilters = ({ doSetSortBy, doSetSearch, openForm }) => {
  const sortOptions = [
    {
      value: "created_at",
      label: "Date Created",
    },
    {
      value: "first_name",
      label: "First Name",
    },
    {
      value: "last_name",
      label: "Last Name",
    },
    {
      value: "email",
      label: "Email",
    },
    {
      value: "phone",
      label: "Phone",
    },
  ];

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center p-4 gap-x-4 filter-container">
        <div>
          <input
            type="search"
            placeholder="Search..."
            className="px-3 py-1 h-[31px] border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            onChange={(e) => doSetSearch(e.target.value)}
          />
        </div>
        <div>
          <span className="mr-1">Sort By:</span>
          <select
            className="border p-1 rounded-md border-gray-400 min-w-28"
            onChange={(e) => doSetSortBy(e.target.value)}
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="pr-4">
        <Button variant="contained" color="primary" onClick={openForm}>
          Add Employee
        </Button>
      </div>
    </div>
  );
};

export default EmployeeFilters;
